import React from 'react';
import { Card, Skeleton } from '@mui/material';
// import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';

// const formatPercentage = (value) => {
//   return {
//     value: Number(value).toFixed(2),
//     unit: '% Avg.'
//   };
// };

// const DeskItem = ({ deskName, availability, loading }) => (
//   <div className="bg-white rounded p-2 mb-2 text-sm shadow-sm">
//     {loading ? (
//       <>
//         <Skeleton variant="text" width="60%" height={24} />
//         <Skeleton variant="text" width="40%" height={20} />
//         <Skeleton variant="text" width="30%" height={20} />
//       </>
//     ) : (
//       <div className="flex items-start gap-2">
//         <FiberManualRecordIcon
//           sx={{
//             color: availability < 90 ? '#ef4444' : '#22c55e',
//             fontSize: '12px',
//             marginTop: '4px'
//           }}
//         />
//         <div>
//           <div className="font-bold">{deskName}</div>
//           <div className="text-xs text-gray-500">Availability: {Number(availability).toFixed(2)}% Avg.</div>
//         </div>
//       </div>
//     )}
//   </div>
// );

const StatItem = ({ label, counts, loading }) => {
  return (
    <div className="bg-white rounded p-3 mb-2">
      {loading ? (
        <>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="40%" height={20} />
        </>
      ) : (
        <div className="flex flex-col">
          <div className="flex items-baseline gap-1">
            <span className="text-xl font-medium">{counts}</span>
          </div>
          <div className="text-sm text-gray-500">{label}</div>
        </div>
      )}
    </div>
  );
};

const DeskAvailabilityCard = ({ data, loading }) => {
  // const averageAvailability = data?.[0]?.average_availability || 0;
  // const desks = data?.[0]?.desks || [];
  // const formattedAvailability = formatPercentage(averageAvailability);
  // const safetyBreachDate = data[0]?.total_unique_keys || 'N/A'
  console.log(data);

  return (
    <div>
      <Card
        className="border relative border-gray-300"
        sx={{
          height: '276px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px'
        }}
      >
        <div className="flex w-full flex-col gap-1 p-3">
          <div className="flex items-center gap-2">
            <SafetyCheckIcon className="text-white rounded-full p-2 text-6xl" style={{ backgroundColor: '#ff1744' }} />

            <div style={{ width: loading ? '120px' : 'auto' }}>
              {loading ? (
                <>
                  <Skeleton variant="text" width="100%" height={40} />
                  <Skeleton variant="text" width="80%" height={28} />
                </>
              ) : (
                <>
                  {/* <div className="flex items-baseline">
                    <span className="text-3xl font-medium">{formattedAvailability.value}</span>
                    <span className="text-sm text-gray-500 ml-1">{formattedAvailability.unit}</span>
                  </div> */}
                  <p className="text-lg font-semibold">Safety Breaches</p>
                </>
              )}
            </div>
          </div>
          <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
            <div className="text-xs text-gray-500 mb-2 italic">More Statistics</div>
            <StatItem
              label={
                <>
                  <span className="text-2xl font-semibold text-black">{data[0]?.kit[0]?.total_unique_keys ?? 0}</span>
                  <br />
                  <span className="text-sm text-gray-500">Without Vest</span>
                </>
              }
            />

            <StatItem
              label={
                <>
                  <span className="text-2xl font-semibold text-black">{data[0]?.helmet[0]?.total_unique_keys ?? 0}</span>
                  <br />
                  <span className="text-sm text-gray-500">Without Helmet</span>
                </>
              }
            />

            <StatItem
              label={
                <>
                  <span className="text-2xl font-semibold text-black">{data[0]?.shoes[0]?.total_unique_keys ?? 0}</span>
                  <br />
                  <span className="text-sm text-gray-500">Without Shoes</span>
                </>
              }
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default DeskAvailabilityCard;
